import React, { Component } from "react";
import {getBookmarks,addBookmarks,removeBookmarks} from '../config/Variables';
export default class BookmarkArticle extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      messagelog: '',
      isLoading: true,
      users: [],
      numberstid: [],
      error: null
    }
    this.handleInputChange = this.handleInputChange.bind(this);
   


  }
 

getBookmarkuser(){
  if (localStorage.getItem('user-info')) {

    let user = JSON.parse(localStorage.getItem('user-info'))
    let datt = fetch(getBookmarks, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json',
        "Authorization": "Bearer " + user.token.access_token,
      },
      body: JSON.stringify(this.state)
    }).then(response => response.json())
      .then(data => {
        data.data.map(({ nid }, index2) => {
          this.state.numberstid.push(nid);
          //this.setState({ numberstid: [this.state.numberstid, tid] })
          this.setState({ numberstid: this.state.numberstid })
          this.state.hobbies.push(nid);
        });
      //}
      });
  }
}
 

  componentDidMount() {
   // console.log(this.myDiv.getAttribute('class'));
  // this.getBookmarkuser();
  }



  async handleInputChange(event) {


    const target = event.target;
    var value = target.value;


   
   


    if (event.target.checked) {
    // this.state.hobbies.splice(value, 1);
    //var nid = document.getElementById('article_node_id').getAttribute('data-value');
    //var nid = '123456'
    const element = event.target;
    let c = element.closest("div");
    var nid=c.getAttribute('data-value');
    var bundle=c.getAttribute('data-type');

    let item = { nid ,bundle };
    if (nid == "") {
      this.setState({ messagelog: "لم يتم الاختيار" });
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(addBookmarks, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
        }
        if(result.message.code =='401'){
        }
        
      }
    }
  }else{

   
    const element = event.target;
    let c = element.closest("div");
    var nid=c.getAttribute('data-value');
    var bundle=c.getAttribute('data-type');

    let item = { nid ,bundle };

    if (nid == "") {
      this.setState({ messagelog: "اختر الكاتب المفضل لديك" });
    } else {
      if (localStorage.getItem('user-info')) {

        let user = JSON.parse(localStorage.getItem('user-info'))
        let result = await fetch(removeBookmarks, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(item)
        });
        result = await result.json();

        if (result.message.code == '200') {
          //localStorage.setItem("user-info", JSON.stringify(result));
          //history('/add');
      //    this.props.samirCallback("success");
      var myEle = document.getElementById('griditem-'+nid);
      if(myEle){
        document.getElementById('griditem-'+nid).style.display = "none";
      }

        }
      }
    }

  }
  }
  render() {
    
   // console.log('Class: ', this.constructor.name);
    var parts = window.location.search.substr(1).split("&");
    var $_GET = {};
    for (var i = 0; i < parts.length; i++) {
        var temp = parts[i].split("=");
        $_GET[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
    }
   
  //  var nidss = document.getElementById('article_node_id').getAttribute('data-value');
    const {
      users,
      error,
      numberstid
    } = this.state;
    if (localStorage.getItem('user-info')) {
  // var nid = document.getElementById('article_node_id').getAttribute('data-value');
 var nid =this.props.nodeid;
 //var bookmarknids =this.props.bookmarksnid;
 var bookmarknids ='3661241+3662486+3661351';


// console.log(nid);
 //console.log("tatmatmatmata");
// console.log(bookmarknids +"samsoum");


    const fruitss = this.state.numberstid;
    const ttt = parseInt(nid);
    const ss = fruitss.includes(ttt); //true
    var randomnumber=Math.floor(Math.random() * 10000)
    if (bookmarknids.includes(nid)) {
      return (

<>
<label htmlFor={`bookmark-tag-${randomnumber}`} className="bookmark-check">
<input type="checkbox" defaultChecked={true}  id={`bookmark-tag-${randomnumber}`} onTouchEnd={this.handleInputChange} onClick={this.handleInputChange}  name={`bookmark-tag-${randomnumber}`}  value="1" className="form-check" />
          <i className="icomoon-icon icon-bookmark-outline"></i>
</label> 
</>


      );
    } else {
      return (
        <>
            <label htmlFor={`bookmark-tag-${randomnumber}`} className="bookmark-check">
            <input type="checkbox" id={`bookmark-tag-${randomnumber}`} name={`bookmark-tag-${randomnumber}`} onTouchEnd={this.handleInputChange} onClick={this.handleInputChange} value="1" className="form-check" />
                <i className="icomoon-icon icon-bookmark-outline"></i>
            </label> 
        </> 
      );
    }

  }else{
    return( 
      <>
          <label htmlFor="bookmark-tag" className="bookmark-check">
              <div  className="form-check modal-toggle" data-id="modal-notification" >
                <i className="icomoon-icon icon-bookmark-outline"></i>
              </div>
          </label> 
          </>  

    ) ;
  }
  }
}
